/** @format */

export const GET_KOS_LOCATIONS = "GET_KOS_LOCATIONS";
export const SYNC_KOS_LOCATIONS = "SYNC_KOS_LOCATIONS";
export const UPDATE_KOS_LOCATION = "UPDATE_KOS_LOCATION";
export const BULK_UPDATE_KOS_ZONE = "BULK_UPDATE_KOS_ZONE";
export const GET_KOS_STATES = "GET_KOS_STATES";
export const GET_KOS_LGAS = "GET_KOS_LGAS";
